import { useStore } from "@/hooks/useStore";
export const useUserPermission = (authKey?: string) => {
   const permissionList = useStore((state) => state.permissionList);
   if (authKey === '*') return true;
   return  authKey ? permissionList.includes(authKey) : true;
};